
enum PricingArchitectureDerivativeRuleType {
	AMOUNT = 'AMOUNT',
	PERCENTAGE = 'PERCENTAGE',
	SAME = 'SAME',
}

export default PricingArchitectureDerivativeRuleType;

